export const environment = {
  version: "0.0.1",
  production: false,
  filenameCsv: "dev-vigp-tarifario-",
  api_url: "https://api.vdiv.dev.protectasecuritycloud.pe/v1/",
  useFakeUserId: false,
  jwtCookieName: 'CognitoIdentityServiceProvider.tcq53h177im86qdnodmalvfcl.tecnicasctr.idToken',
  fakeUserId: 'dev-fake-sub-123',
  encryptionPassword: 'M@t3r1@Gr1'
};
